import { render, staticRenderFns } from "./HouseTabComponent.vue?vue&type=template&id=785ba864&scoped=true&"
import script from "./HouseTabComponent.vue?vue&type=script&lang=ts&"
export * from "./HouseTabComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ba864",
  null
  
)

export default component.exports